// Auto-import SASS generated CSS
import './index.css';

export {default as Carousel, CarouselProps} from './Carousel';
export {default as default} from './Carousel';
